import { i18n } from '@/i18n';

export const DefaultChartPalette = [
  '#0665a2',
  '#ffc930',
  '#e96455',
  '#e11272',
  '#57df7f',
  '#820970',
  '#7f2ccb',
  '#52ffee',
  '#4adf62',
  '#345511',
];

export const DashboardDataType = {
  DASH: 'dash',
};

export const DashboardAiPageContext = {
  SCHEMA_VERSION: '1',
  ENTITY_TYPE: 'dashboard',
  ROUTE_KEY: 'dashboard.view',
};

export const StringConstants = {
  CLIENT: 'client',
  ID: 'id',
  OBJECT: 'object',
  NAME: 'name',
  FUNCTION: 'function',
  TEXT: 'text',
  TITLE: 'title',
  TYPE: 'type',
  WIDGET_IDS: 'widget_ids',
  METADATA: 'metadata',
};

export const DashboardIconClass = {
  FONT_BASE: ['fa', 'fa-font', 'm-r-10'],
  FONT_PREFIX: 'font-',
};

export const DashboardReportingOptions = {
  OFF: 'off',
  SECTION: 'section',
  DASHBOARD: 'dashboard',
};

export const DashboardFilterKey = {
  ALL: 'all',
  RECENT: 'recent',
  CREATED: 'created',
  SHARED: 'shared',
  CLIENT: 'client',
  PREDEFINED: 'predefined',
};

export const DashboardPathName = {
  DASHBOARDS: 'dashboards',
  DASHBOARD_VUE: 'dashboard:vue',
  DASHBOARD_SECTION: 'dashboard:section',
  DASHBOARD_WIDGET: 'dashboard:widget',
  FAV_DASHBOARD_VUE: 'fav-dashboard:vue',
  FAV_DASHBOARD_SECTION: 'fav-dashboard:section',
  FAV_DASHBOARD_WIDGET: 'fav-dashboard:widget',
  DASHBOARDTEMPLATES: 'dashboardtemplates',
  LEADS_DASHBOARD: 'leadsdashboard:vue',
  LEADS_DASHBOARD_SECTION: 'leadsdashboard:section',
  LEADS_DASHBOARD_WIDGET: 'leadsdashboard:widget',
  LEADS_EDIT: 'leads-edit:vue',
  MANAGE_LEADS: 'manage-leads:vue',
  SHARE_LINKS: 'sharelinks:vue',
};

export const DashboardPermalinkViewModelStatus = {
  ACTIVE: 'active',
  REVOKED: 'revoked',
  EXPIRED: 'expired',
};

// Server clamps to the same ceiling (DashboardPermalinkViewModel::EXPIRY_MAX_DAYS).
export const MAX_EXPIRY_DAYS = 180;

// Internal date stored for a Never link (DashboardPermalinkViewModel::EXPIRY_NEVER_YEARS).
export const NEVER_EXPIRY_YEARS = 10;

// PermalinkExpiryPicker modes. NEVER is only offered on allowlisted instances (TR-7804).
export const PermalinkExpiryMode = {
  IN_DAYS: 'in_days',
  EXACT_DATE: 'exact_date',
  NEVER: 'never',
};

export const LEADS_DASHBOARD_ROUTE_NAMES = [
  DashboardPathName.LEADS_DASHBOARD,
  DashboardPathName.LEADS_DASHBOARD_SECTION,
  DashboardPathName.LEADS_DASHBOARD_WIDGET,
];

export const FontSize = {
  SIZE_SMALL: 'small',
  SIZE_MEDIUM: 'medium',
  SIZE_LARGE: 'large',
};

export function GetDashboardFontSize() {
  return [
    { label: i18n.$t(FontSize.SIZE_SMALL), value: FontSize.SIZE_SMALL },
    { label: i18n.$t(FontSize.SIZE_MEDIUM), value: FontSize.SIZE_MEDIUM },
    { label: i18n.$t(FontSize.SIZE_LARGE), value: FontSize.SIZE_LARGE },
  ];
}

export const NavItemGroupKey = {
  CLIENT_DASHBOARDS: 'client_dashboards',
  SHARED_DASHBOARDS: 'shared_dashboards',
};

export const PageEntity = {
  PAGE_LEADS: 'leads',
  PAGE_INDUSTRY_BENCHMARK: 'industrybenchmark',
  PAGE_EMAILS_OVERVIEW: 'emailsoverview',
  PAGE_PREDEFINED_CATEGORY_DASHBOARD: 'predefinedcategorydashboard',
};

export function GetLayoutSortOptions() {
  return [
    { label: i18n.$t('Most Used'), value: 'library_download_count' },
    { label: i18n.$t('Recently Uploaded'), value: 'created_at' },
  ];
}

export const DashboardRoute = {
  DASHBOARDS: 'dashboards',
  DASHBOARD: 'dashboard',
  FAV_DASHBOARDS: 'fav/dashboards',
  FAV_DASHBOARD: 'fav/dashboard',
  LEADS: 'leads',
  MANAGE_LEADS: 'manageleads',
  SHARE_LINKS: 'sharelinks',
};

export const DashboardTemplateTab = {
  DASHBOARD_TEMPLATES: 'dashboard_templates',
  SECTION_TEMPLATES: 'section_templates',
  WIDGET_TEMPLATES: 'widget_templates',
  DASHBOARD_TAGS: 'dashboard_tags',
  SECTION_TAGS: 'section_tags',
  WIDGET_TAGS: 'widget_tags',
};

export const DashboardRouteSegment = {
  COPY: 'copy',
  ENABLE_SUMMARY: 'enablesummary',
  PUBLISH: 'publish',
  SAVE: 'save',
  RESIZE: 'resize',
};

export const LayoutIconTypes = {
  CUSTOM: 'custom',
  NONE: 'none',
  DEFAULT: 'default',
};

export const DashboardEventType = {
  DASHBOARD_FILTER_PANEL_OLD_UI_RESET: 'DashboardFilterPanelOldUIReset',
  DASHBOARD_FILTER_NEW_UI_RELOAD: 'DashboardFilterNewUIReload',
  ADD_DATA_WIDGET: 'AddDataWidgetEvent',
  EDIT_DATA_WIDGET: 'EditDataWidgetEvent',
  EDIT_DATE_RANGE: 'DateRangeEdit',
  PUBLIC_SHARE_RELOADING: 'PublicShareReloading',
  ADD_WIDGET: 'AddWidgetEvent',
  ADD_ADMIN_WIDGET: 'AddAdminWidgetEvent',
  EDIT_ADMIN_WIDGET: 'EditAdminWidgetEvent',
  QUICK_DOWNLOAD: 'QuickDownloadEvent',
  ADD_MEDIA_WIDGET: 'AddMediaWidgetEvent',
  EDIT_MEDIA_WIDGET: 'EditMediaWidgetEvent',
  EDIT_DASHBOARD: 'EditDashboard',
  MANAGE_SECTIONS: 'ManageSections',
  EDIT_SECTION_DRAW_OPTIONS: 'EditSectionDrawOptions',
  PUBLISH_TO_LIBRARY: 'PublishToLibraryEvent',
  RESET_WIDGET_COLOR_PALETTE: 'ResetWidgetColorPalette',
  BUILD_PDF_REPORT_START: 'BuildPDFReportStartEvent',
  BUILD_PDF_REPORT_DOWNLOAD: 'BuildPDFReportDownloadEvent',
  EXPORT_TO_REPORT_STUDIO: 'ExportToReportStudioEvent',
  EDIT_REPORTING_OPTIONS: 'EditReportingOptionsEvent',
  DASHBOARD_TOGGLE_FAVORITE_EVENT: 'DashboardToggleFavoriteEvent',
  SEGMENT_EVENTS: 'SegmentEvents',
  EXECUTIVE_SUMMARY_SELECTED: 'ExecutiveSummarySelected',
  EXECUTIVE_SUMMARY_HIDE_INLINE_EDITOR: 'ExecutiveSummaryHideInlineEditor',
  RESIZE_MODE_ENABLED: 'ResizeModeEnabled',
  DASHBOARD_SETTINGS_UPDATED: 'DashboardSettingsUpdated',
  LAYOUT_UPDATED: 'LayoutsUpdated',
  LAYOUT_ORDER_CHANGED: 'LayoutOrderChanged',
  DESTROY_DASHBOARD_RESOURCES: 'DestroyDashboardResources',
  OPEN_MODAL_AI_WIDGET: 'OpenModalAiWidgetEvent',
  VIEWPORT_WIDGETS_LOADED: 'ViewportWidgetsLoaded',
};

export const DashboardPerformanceSessionType = {
  DASHBOARD_LOAD: 'dashboard_load',
  LAYOUT_LOAD: 'layout_load',
};

export const ModalIcons = {
  COLOR_WARNING: '#f0ad4e',
  COLOR_ERROR: '#d9534f',
  ICON_ERROR: 'icon-times animateXMark',
  ICON_WARNING: 'icon-exclamation',
};

export const DashboardElements = {
  WIDGET: 'widget',
  DASHBOARD: 'dashboard',
  LAYOUT: 'section',
};

export const DashboardCreatedFrom = {
  FREEHAND: 'freehand',
  TEMPLATE: 'template',
};

export const DASHBOARD = 'dashboard';
export const REPORT_STUDIO = 'report_studio';

export const LayoutModals = {
  LAYOUT_ASSIGN_MODAL: 'LayoutAssignModal',
  LAYOUT_ICON_MODAL: 'LayoutIconModal',
  PUBLISH_MODAL: 'PublishModal',
  LAYOUT_DELETE_MODAL: 'LayoutDeleteModal',
  LAYOUT_DUPLICATE_MODAL: 'LayoutDuplicateModal',
};

export const BLANK_LAYOUT_ADDED = 'blank_layout_added';

export const DASHBOARD_RAW_VALUES = {
  VALUES: 'values',
};

export const AllDataSourceListParams = {
  primaryKey: 'uniqueKey',
  valueIsObject: false,
  skipProcessOptions: true,
  showAllOptions: true,
  canClearSelection: false,
  includeExclusiveLiveServices: true,
};

export const DASHBOARD_LIST_FIELDS = [
  'id',
  'title',
  'is_predefined',
  'is_in_library',
  'is_favorite',
  'can_favorite',
  'is_template',
  'is_locked',
  'reporting_profiles',
  'cluster',
  'folder_id',
  'folder_name',
  'metadata',
  'has_widgets_on_first_section',
  'updated_at',
  'created_at',
];

export const DASHBOARD_EXPORT_SECTION_OPTIONS = {
  CURRENT: 'current',
  ALL: 'all',
  CUSTOM: 'custom',
};

export const MANAGE_INLINE_RENAME_WRAPPER = 'manage-inline-rename-wrapper';
